import { render, staticRenderFns } from "./LongBtn.vue?vue&type=template&id=27811176&scoped=true"
import script from "./LongBtn.vue?vue&type=script&lang=js"
export * from "./LongBtn.vue?vue&type=script&lang=js"
import style0 from "./LongBtn.vue?vue&type=style&index=0&id=27811176&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27811176",
  null
  
)

export default component.exports